var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoElement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "zbfcvz1y3a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2bc5b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35ddcb"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#zbfcvz1y3a)",
    d: "M0 0h25.5A25.5 25.5 0 0 1 51 25.5 25.5 25.5 0 0 1 25.5 51 25.5 25.5 0 0 1 0 25.5V0z",
    transform: "rotate(180 25.5 25.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoElement);
export default __webpack_public_path__ + "static/media/logo_element.82d7018e593a78c42440f9d6d8f05951.svg";
export { ForwardRef as ReactComponent };